import { api } from './api.js';

/** Talk entry invites the assistant only after the person's microphone connects.
 * An invitation acknowledgment never stands in for a worker joining the room. */
export async function requestCallAssistant(meetingId: string, requested: boolean, alreadyJoined: boolean): Promise<string | null> {
  if (!requested || alreadyJoined) return null;
  try {
    await api.meetings.inviteJabberr(meetingId);
    return null;
  } catch {
    return 'Jabberr could not join. Use Invite Jabberr to retry.';
  }
}
